import { receivingListStateName } from '../../../../components/tickets/ticketOverview/ticketOverview.state';
import { authorizationReceivingStateName } from '../../../../components/ticket/states/authorizationReceiving/authorizationReceiving.state';
import { financesStateName } from '../../../../components/ticket/states/finances/finances.state';
import { confirmStateName } from '../../../../components/ticket/states/confirm/confirm.state';
import { standingOrdersStateName } from '../../../../components/ticket/states/standingOrders/standingOrders.state';
import { dwsStartedState } from '../../../../components/ticket/states/dws/started/started.state';
import { waitForTransferringStateName } from '../../../../components/ticket/states/waitForTransferring/waitForTransferring.state';
import { downloadBalanceListStateName } from '../../../../components/ticket/states/downloadBalanceList/downloadBalanceList.state';
import { receivingClosedStateName } from '../../../../components/ticket/states/closed/closed.state';
import { receivingCompletedStateName } from '../../../../components/ticket/states/completed/completed.state';
import { receivingCreateRequestStateName } from '../../../../components/tickets/create/receiving/createRequest/createRequest.state';
import { TicketType } from '../../../../components/ticket/ticket.constants';
import { UserPermissions } from '../../../user/user.roles';
import { FeatureFlagNames } from '../../../featureFlags/featureFlags';

export const ReceivingTab = {
  id: TicketType.Receiving,
  ref: receivingListStateName,
  text: 'navbar.link.receiving.title',
  activeStates: [
    authorizationReceivingStateName,
    dwsStartedState,
    financesStateName,
    confirmStateName,
    standingOrdersStateName,
    waitForTransferringStateName,
    downloadBalanceListStateName,
    receivingClosedStateName,
    receivingCompletedStateName,
  ],
  requiresAuth: true,
  permissions: [
    UserPermissions[TicketType.Receiving].Read,
    UserPermissions[TicketType.Receiving].Create,
  ],
  dropdown: {
    tickets: {
      ref: receivingListStateName,
      text: 'navbar.link.receiving.tickets.title',
      icon: 'fa fa-fw m-right-xs-5 fa-tasks',
      permissions: [UserPermissions[TicketType.Receiving].Read],
    },
    request: {
      ref: `${receivingCreateRequestStateName}({nachlass: false})`,
      text: 'navbar.link.receiving.createRequest.title',
      icon: 'fa fa-fw m-right-xs-5 fa-pencil-square-o',
      permissions: [UserPermissions[TicketType.Receiving].Create],
    },
    nachlass: {
      ref: `${receivingCreateRequestStateName}({nachlass: true})`,
      text: 'navbar.link.receiving.nachlass.title',
      icon: 'fa fa-fw m-right-xs-5 fa-cloud',
      permissions: [UserPermissions[TicketType.Receiving].Create],
      featureFlag: FeatureFlagNames.FF_NACHLASS,
    },
  },
};
